import { createFileRoute } from '@tanstack/react-router';
import { ThemePickerDemo } from '#/components/notes/markdown-components/theme-picker.tsx';

export const Route = createFileRoute('/draft/theme-picker')({
	component: RouteComponent,
});

function RouteComponent() {
	return <ThemePickerDemo />;
}
